var map = {
	"./icon-1.svg": "./src/assets/icon/weather/icon-1.svg",
	"./icon-11.svg": "./src/assets/icon/weather/icon-11.svg",
	"./icon-12.svg": "./src/assets/icon/weather/icon-12.svg",
	"./icon-13.svg": "./src/assets/icon/weather/icon-13.svg",
	"./icon-14.svg": "./src/assets/icon/weather/icon-14.svg",
	"./icon-15.svg": "./src/assets/icon/weather/icon-15.svg",
	"./icon-16.svg": "./src/assets/icon/weather/icon-16.svg",
	"./icon-17.svg": "./src/assets/icon/weather/icon-17.svg",
	"./icon-18.svg": "./src/assets/icon/weather/icon-18.svg",
	"./icon-19.svg": "./src/assets/icon/weather/icon-19.svg",
	"./icon-2.svg": "./src/assets/icon/weather/icon-2.svg",
	"./icon-20.svg": "./src/assets/icon/weather/icon-20.svg",
	"./icon-21.svg": "./src/assets/icon/weather/icon-21.svg",
	"./icon-22.svg": "./src/assets/icon/weather/icon-22.svg",
	"./icon-23.svg": "./src/assets/icon/weather/icon-23.svg",
	"./icon-24.svg": "./src/assets/icon/weather/icon-24.svg",
	"./icon-25.svg": "./src/assets/icon/weather/icon-25.svg",
	"./icon-26.svg": "./src/assets/icon/weather/icon-26.svg",
	"./icon-29.svg": "./src/assets/icon/weather/icon-29.svg",
	"./icon-3.svg": "./src/assets/icon/weather/icon-3.svg",
	"./icon-33.svg": "./src/assets/icon/weather/icon-33.svg",
	"./icon-34.svg": "./src/assets/icon/weather/icon-34.svg",
	"./icon-35.svg": "./src/assets/icon/weather/icon-35.svg",
	"./icon-36.svg": "./src/assets/icon/weather/icon-36.svg",
	"./icon-37.svg": "./src/assets/icon/weather/icon-37.svg",
	"./icon-38.svg": "./src/assets/icon/weather/icon-38.svg",
	"./icon-39.svg": "./src/assets/icon/weather/icon-39.svg",
	"./icon-4.svg": "./src/assets/icon/weather/icon-4.svg",
	"./icon-40.svg": "./src/assets/icon/weather/icon-40.svg",
	"./icon-41.svg": "./src/assets/icon/weather/icon-41.svg",
	"./icon-42.svg": "./src/assets/icon/weather/icon-42.svg",
	"./icon-43.svg": "./src/assets/icon/weather/icon-43.svg",
	"./icon-44.svg": "./src/assets/icon/weather/icon-44.svg",
	"./icon-5.svg": "./src/assets/icon/weather/icon-5.svg",
	"./icon-6.svg": "./src/assets/icon/weather/icon-6.svg",
	"./icon-7.svg": "./src/assets/icon/weather/icon-7.svg",
	"./icon-8.svg": "./src/assets/icon/weather/icon-8.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icon/weather sync recursive ^\\.\\/icon\\-.*\\.svg$";